import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './effects';
import {AppReducer} from './reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('app', AppReducer),
    EffectsModule.forFeature([AppEffects])
  ],
  providers: [AppEffects]
})
export class AppStoreModule {

}
